import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { MailWarning, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const VerifyEmailBanner = () => {
  const { user } = useAuth();
  const { t } = useLanguage();
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await axios.post(`${API_URL}/api/auth/resend-verification`, {}, { withCredentials: true });
      toast.success(t('verificationEmailSent'));
    } catch (e) {
      toast.error(e.response?.data?.detail || t('error'));
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      data-testid="verify-email-banner"
      className="mx-2 md:mx-4 mt-3 rounded-2xl bg-amber-50 border border-amber-200 px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3"
    >
      <MailWarning className="w-5 h-5 text-amber-500 shrink-0" />
      <div className="flex-1">
        <p className="text-sm font-bold text-amber-900">{t('verifyEmailTitle')}</p>
        <p className="text-sm text-amber-700">{t('verifyEmailDesc', { email: user.email })}</p>
      </div>
      <Button
        onClick={handleResend}
        disabled={sending}
        size="sm"
        data-testid="resend-verification-btn"
        className="rounded-full bg-amber-500 hover:bg-amber-600 text-white shrink-0"
      >
        {sending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
        {t('resendVerification')}
      </Button>
    </div>
  );
};

export default VerifyEmailBanner;
